module.exports = __webpack_public_path__ + "static/media/ai-logo.7aab19fc.png";